<template>
  <div id="register">
    <div v-if="isPC" class="register f">
      <div class="register-left">
        <div class="head">
          <div class="logo pointer" @click="$router.push('/home')"><img src="@/assets/img/logo.png" /></div>
        </div>
        <div class="content f-c">
          <div class="register-box f--c fd-c">
            <div v-if="step !== 1" class="back color-green pointer" @click="backStep"><i class="el-icon-arrow-left"></i> {{ $t('Home.Register.Back') }}</div>
            <h4>{{ $t('Home.Register.SignUp') }}</h4>
            <div style="color:#909399;">
              {{ $t('Home.Register.Tips1') }}
              <el-button type="text" @click="$router.push('/login')">{{ $t('Home.Register.SignIn') }}</el-button>
            </div>
            <div class="step-tab f-b-c">
              <div class="item f-c-c sel">{{ $t('Home.Register.Tips2') }}</div>
              <div class="item f-c-c" :class="{ sel: step === 5 }">{{ $t('Home.Register.Tips3') }}</div>
            </div>
            <div v-show="step <= 3" class="register-question">
              <RegisterQuestion ref="registerQuestion" :step="step" @selectQuestion="selectQuestion"></RegisterQuestion>
              <el-button :disabled="step <= 3 && !questions['question' + this.step]" type="primary" class="register-btn" @click="handleNext">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
            </div>
            <div v-show="step === 4" class="register-info">
              <el-form label-position="top" label-width="80px" ref="resetBusiness" :model="business">
                <el-form-item :label="$t('Home.Register.BrandName')">
                  <el-input v-model.trim="business.brandName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Home.Register.WebsiteURL')">
                  <el-input v-model.trim="business.websiteURL"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Home.Register.Referrer')">
                  <el-select v-model="business.referrer" style="width:100%">
                    <el-option label="Google Search" :value="1"></el-option>
                    <el-option label="Shopify App Store" :value="2"></el-option>
                    <el-option label="Youtube" :value="3"></el-option>
                    <el-option label="FaceBook/Instagram" :value="4"></el-option>
                    <el-option label="Blog Mentioned" :value="5"></el-option>
                    <el-option label="Other" :value="6"></el-option>
                    <!-- <el-option :label="$t('Home.Register.Tips4')" :value="1"></el-option>
                    <el-option :label="$t('Home.Register.Tips5')" :value="2"></el-option>
                    <el-option :label="$t('Home.Register.Tips6')" :value="3"></el-option>
                    <el-option :label="$t('Home.Register.Tips7')" :value="4"></el-option>
                    <el-option :label="$t('Home.Register.Tips8')" :value="5"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom:0;">
                  <el-button type="primary" class="register-btn" @click="handleNext">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-show="step === 5" class="register-info">
              <el-form label-position="top" label-width="80px" ref="userForm" :model="userForm" :rules="rules">
                <el-form-item :label="$t('Home.Register.FullName')" prop="fullName">
                  <el-input v-model.trim="userForm.fullName" :placeholder="$t('Home.Register.FullName')"></el-input>
                </el-form-item>
                <el-form-item v-if="loginMethod === 'phone'" :label="$t('Home.Register.PhoneNumber')" prop="phone">
                  <el-input v-model.trim="userForm.phone" @input="checkPhone" :placeholder="$t('Home.Register.PhoneNumber')">
                    <el-select v-model="areaCode" filterable slot="prepend" style="width:88px;">
                      <el-option v-for="item in areaCodeList" :label="item.areaCode" :value="item.areaCode" :key="item.countryCode+item.areaCode">
                        <span style="float:left;font-size:13px;color:#909399;">{{ item.countryNameEn }}</span>
                        <span style="float:right;font-size:13px;color:#303133;">{{item.areaCode}}</span>
                      </el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
                <el-form-item v-else :label="$t('Home.Register.EmailID')" prop="email">
                  <el-input v-model.trim="userForm.email" :placeholder="$t('Home.Register.EmailID')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Home.Register.VerificationCode')" prop="verificationCode" class="verification">
                  <el-input v-model.trim="userForm.verificationCode" :placeholder="$t('Home.Register.VerificationCode')" style="margin-right:2%"></el-input>
                  <span class=" pointer" size="large" @click="getVertificationCode" v-if="seconds===0">
                    <el-button class="send-button" :loading="sendLoading">{{$t('Home.Register.Send')}}</el-button>
                  </span>
                  <el-button class="send-button" v-else disabled>{{seconds}}S</el-button>
                </el-form-item>
                <el-form-item :label="$t('Home.Register.Password')" prop="password">
                  <el-input type="password" v-model.trim="userForm.password" :placeholder="$t('Home.Register.Password')" show-password autocomplete="new-password"></el-input>
                </el-form-item>
                <p style="margin-bottom:20px;color:#909399;font-size:12px">{{ $t('Home.Register.PasswordCheckRule') }}</p>
                <el-form-item style="margin-bottom:0;">
                  <el-button type="primary" class="register-btn" :loading="loading" @click="handleSignUp('userForm')">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
                </el-form-item>
              </el-form>
              <LoginMethod :loginMethod="loginMethod"  @clickGoogle="isClickGoogle = true" @changeLoginMethod="(method) => loginMethod = method"></LoginMethod>
            </div>
            <div class="terms">
              <el-checkbox v-model="checked" :class="{ showError }" @change="showError = false"></el-checkbox>
              {{ $t('Home.Register.Tips9') }}
              <span class="pointer color-green" @click="jump('/terms-conditions')">{{ $t('Home.Register.Tips10') }}</span>
              <span class="pointer color-green" @click="jump('/privacy-policy')">{{ $t('Home.Register.Tips11') }}</span>
              {{ $t('Home.Register.Tips12') }}
            </div>
          </div>
        </div>
      </div>
      <div class="right-banner">
        <LoginBanner></LoginBanner>
      </div>
    </div>
    <div v-else class="mobile-register">
      <mobile-register></mobile-register>
      <!-- <div class="f-b-c register-top">
        <h1>{{$t('Home.Register.SignUpForFree')}}</h1>
        <el-button round @click="toSignIn" class="mobile-login-btton">{{$t('Home.Register.SignIn')}}</el-button>
      </div>
      <el-form ref="userForm" :model="userForm" :rules="rules">
        <el-form-item prop="fullName">
          <el-input v-model.trim="userForm.fullName" :placeholder="$t('Home.Register.FullName')"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model.trim="userForm.email" :placeholder="$t('Home.Register.EmailID')"></el-input>
        </el-form-item>
        <el-form-item prop="verificationCode">
          <el-input style="width:68%;margin-right:2%" :placeholder="$t('Home.Register.VerificationCode')" v-model.trim="userForm.verificationCode" @blur="checkVerificationCode"></el-input>
          <span class="pointer" size="large" @click="getVertificationCode" v-if="seconds===0">
            <el-button class="mobile-code-button code-button" :loading="sendLoading">{{$t('Home.Register.Send')}}</el-button>
          </span>
          <el-button class="mobile-code-button code-button" v-else disabled>{{seconds}}S</el-button>
        </el-form-item>
        <p class="code-tip" v-if="seconds===0">{{$t('Home.Register.AVerificationVodeWillBeSentToYourEmail')}}</p>
        <p class="code-tip" v-else>{{$t('Home.Register.TipsOne')}}</p>
        <el-form-item prop="password">
          <el-input type="password" :placeholder="$t('Home.Register.Password')" v-model.trim="userForm.password" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('Home.Register.ReferralCode')" v-model.trim="userForm.promotionCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="register-btn mobile-register-btn" @click="handleSignUp('userForm')">{{$t('Home.Register.SignUpForFree')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="mobile-help">
        {{$t('Home.Register.TipsTwo')}}
        <a href="/terms-conditions" style="color:#99c41c;">{{$t('Home.Register.Terms')}} & {{$t('Home.Register.Conditions')}}</a> ,
        <a href="/privacy-policy" style="color:#99c41c;">{{$t('Home.Register.PrivacyPolicy')}}</a> {{$t('Home.Register.AndFeesAndCancellation')}}
      </div>
      <template>
        <div class="or-box f-c-c">
          <div></div>
          <span>OR</span>
          <div></div>
        </div>

        // Google/facebook登录
        <div class="f-c-c">
          <div class="g-signin2" data-onsuccess="googleLoginSuccessCb" @click="isClickGoogle = true"></div>
        </div>
      </template> -->
    </div>
    <el-dialog :visible.sync="dialogVisible" :width="dialogWidth" :center="true" :show-close="false" :before-close="handleClose">
      <span class="userinfoTitle">{{$t('signupUser.questionTile')}}</span>
      <el-checkbox-group v-model="questionnaireAnswers" class="f fd-c">
        <el-checkbox :label="item.value" v-for="(item,index) in userInfos" :key="index">{{item.name}}</el-checkbox><br>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" style="margin-right:15px">{{$t('Home.Register.Closure')}}</el-button>
        <el-button type="primary" @click="submitUserType">{{$t('Home.Register.Submit')}}</el-button>
      </span>
    </el-dialog>
    <third-party-registration ref="thirdPartyRegistration" v-model="thirdPartyRegistrationVisibled" @registerSuccess="thirdPartyLogin" />
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { checkEmail, sixNumber, hasCapital, hasLowercase, hasNumber, telephoneNumber, generalPhoneNumber } from '@/util/validate'
import { encrypt } from '@/util/encryp.js'
import googleLoginMixin from '../js/googleLogin.js'
import LoginBanner from './components/LoginBanner.vue'
import RegisterQuestion from './components/RegisterQuestion.vue'
import LoginMethod from './components/LoginMethod.vue'
import MobileRegister from './MRegister.vue'

let validateEmail = (rule, value, callback) => {
  if (checkEmail(value)) {
    callback()
  } else {
    callback(new Error('Please enter your vaild email'))
  }
}
let validSixNumber = (rule, value, callback) => {
  if (sixNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter a six-digit verification code'))
  }
}
let checkPhoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value) || generalPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}
export default {
  components: { LoginBanner, RegisterQuestion, LoginMethod, MobileRegister },
  mixins: [googleLoginMixin],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('Home.Register.PasswordCheck1')))
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error(this.$t('Home.Register.PasswordCheck2')))
      } else if (!hasCapital(value) || !hasLowercase(value) || !hasNumber(value)) {
        callback(new Error(this.$t('Home.Register.PasswordCheck3')))
      } else {
        callback()
      }
    }

    return {
      userInfos: [
        { name: this.$t('signupUser.answer1'), value: '服装网店' },
        { name: this.$t('signupUser.answer2'), value: '服装门店' },
        { name: this.$t('signupUser.answer3'), value: '服装网店和门店' },
        { name: this.$t('signupUser.answer4'), value: 'Influencer' },
        { name: this.$t('signupUser.answer5'), value: '消费者' },
        { name: this.$t('signupUser.answer6'), value: '其他' }
      ],
      validSixNumber,
      checkPassword: '',
      userForm: {
        email: '',
        password: '',
        userRole: 1,
        userSource: 'google'
      },
      questionForm: {
        userId: undefined,
        questionnaireAnswers: undefined
      },
      dialogWidth: '',
      dialogVisible: false,
      hasCode: false,
      sendLoading: false,
      seconds: 0,
      timer: null,
      questionnaireAnswers: [],
      rules: {
        fullName: [{ required: true, message: this.$t('Home.Register.FullNameCheck1'), trigger: 'blur' }, { min: 2, max: 255, trigger: 'blur', message: this.$t('Home.Register.FullNameCheck2') }],
        email: [{ validator: validateEmail, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }],
        phone: [{ validator: checkPhoneNumber, trigger: 'blur' }, { required: true, message: 'Please enter your vaild Phone Number', trigger: 'blur' }],
        verificationCode: [{ validator: validSixNumber, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      passCheck: false,
      currentCountry: '',
      signInForm: {
        grant_type: 'password',
        client_id: 'client_general',
        client_secret: 'genera_secret',
        username: '',
        password: ''
      },
      questions: {
        question1: '',
        question2: '',
        question3: ''
      },
      business: {
        brandName: '',
        websiteURL: '',
        referrer: ''
      },
      step: 1,
      checked: false, // 是否勾选免责声明
      showError: false,
      loginMethod: 'email', // 登录方式
      areaCode: '+1', // 默认选择 +1美国区号
      areaCodeList: [],
      loading: false
    }
  },
  created() {
    if (this.$route.params.email) {
      this.userForm.email = this.$route.params.email
    }
    if (this.isPC) {
      this.dialogWidth = '30%'
    } else {
      this.dialogWidth = '90%'
    }
    this.systemAddressInfo()
  },
  computed: {
    countryList() {
      return this.$store.state.common.countrySelectList
    }
  },
  methods: {
    selectCountry(country) {
      this.currentCountry = country
    },
    // 校验输入的电话号码（只能为数字）
    checkPhone() {
      this.userForm.phone = this.userForm.phone.replace(/\D/g, '')
    },
    // 获取验证码
    getVertificationCode() {
      if (this.loginMethod === 'phone' && (!this.userForm.phone || !this.userForm.fullName)) {
        return this.$message.warning(this.$t('promptText.msg48'))
      }
      if (this.loginMethod === 'email' && (!this.userForm.email || !this.userForm.fullName)) {
        return this.$message.warning(this.$t('promptText.msg29'))
      }
      if (!this.checked) {
        this.showError = true
        return this.$message.warning(this.$t('promptText.msg50'))
      }
      this.sendLoading = true
      let data = { fullName: this.userForm.fullName }
      if (this.loginMethod === 'phone') data.phone = `${this.areaCode} ${this.userForm.phone}`
      else data.email = this.userForm.email
      data.token = encrypt(this.userForm.email + Math.random())
      API.getEmailAuthentication(data).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        this.hasCode = true
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.$forceUpdate()
            return
          }
          --this.seconds
        }, 1000)
        this.$message.success(this.$t('promptText.msg28'))
      }).catch(result => {
        this.$message.error(result.data.message)
      }).finally(() => {
        this.sendLoading = false
      })
    },

    // 验证验证码
    checkVerificationCode() {
      if ((this.userForm.email || this.userForm.phone) && this.userForm.verificationCode) {
        let form = {
          email: this.userForm.email,
          phone: `${this.areaCode} ${this.userForm.phone}`,
          verificationCode: this.userForm.verificationCode
        }
        if (this.loginMethod === 'phone') delete form.email
        else delete form.phone
        API.checkVerificationCode(form).then(res => {
          if (res.code === 10000) this.passCheck = true
        }).catch(result => {
          this.$message.error(result.data.message)
        })
      }
    },
    toSignIn() {
      this.$router.push('/login?from=register&autoLogin=1')
    },
    handleSignUp(userForm) {
      this.$refs.userForm.validate(valid => {
        if (!valid) return
        // if (!this.passCheck) return this.$message.error(this.$t('promptText.msg30'))
        this.signIn()
      })
    },
    handleClose() {
      this.questionnaireAnswers = []
      this.dialogVisible = false
      this.toSignIn()
    },
    submitUserType() {
      this.questionForm.questionnaireAnswers = this.questionnaireAnswers.toString()
      API.sendQuestionnaireAnswers(this.questionForm).then(res => {
        if (res.code === 10000) {
          this.$message.success(this.$t('promptText.msg31'))
          this.handleClose()
          if (this.questionForm.questionnaireAnswers.indexOf('店') > -1) {
            this.handleLogin()
            localStorage.setItem('isSeller', true)
          }
        }
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },

    // 注册
    signIn() {
      let form = _.cloneDeep(this.userForm)
      form.password = encrypt(form.password)
      form.referrer = localStorage.getItem('referrer') || undefined
      form.equipment = this.$store.state.isPC ? 'pc' : 'mobile'
      form.area = this.currentCountry
      // 如果用户是平台引流进入kakaclo，注册的时候带上推广码,来源
      if (this.$store.state.common.promotionCode) {
        form.inviteCode = this.$store.state.common.promotionCode
        form.userSource = this.$store.state.common.promotionSource
      }
      if (this.loginMethod === 'phone') {
        delete form.email
        form.phone = `${this.areaCode} ${form.phone}`
      } else delete form.phone
      form.questionnaireAnswers = JSON.stringify({
        questions: this.questions,
        business: this.business
      })
      this.loading = true
      API.signIn(form)
        .then(res => {
          if (res.code === 10000) {
            this.$message.success(this.$t('promptText.msg32'))
            localStorage.setItem('registerInfo', JSON.stringify({
              phone: this.userForm.phone,
              areaCode: this.areaCode,
              loginMethod: this.loginMethod,
              email: form.email,
              password: form.password
            }))
            this.signInForm.username = form.email
            this.signInForm.password = form.password
            this.hasCode = false
            this.$refs.userForm.resetFields()
            this.toSignIn()
          } else this.$message(res.message)
        })
        .catch(result => {
          this.$message.error(result.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    couponCodeCheck(value) {
      if (!this.userForm.promotionCode) {
        return
      }
      API.couponCodeCheck({
        couponCode: this.userForm.promotionCode,
        discountRule: 4
      }).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },
    handleLogin() {
      // this.$refs.loginForm.validate((valid) => {
      // if (!valid) return
      let form = { ...this.signInForm }
      let data = new FormData()
      // form.password = encrypt(form.password)
      data.append('grant_type', form.grant_type)
      data.append('client_id', form.client_id)
      data.append('client_secret', form.client_secret)
      data.append('username', form.username)
      data.append('password', form.password)

      API.login(data).then(this.loginSuccessCb).catch(result => {
        this.$message.error(result.message)
        // this.createLoginLog()
      }).finally(() => {
        this.loadingBtn = false
      })
      // })
    },

    // 上一步
    backStep() {
      if (this.step === 4 && this.questions.question1 === 2) {
        this.step = 1
        return
      }
      if (this.step <= 1) return
      this.step--
    },
    // 选择问题
    selectQuestion(type, value) {
      this.$set(this.questions, `question${type}`, value)
    },
    // 下一步
    handleNext() {
      if (this.step === 1 && this.questions.question1 === 2) {
        this.step = 4
        this.questions.question2 = ''
        this.questions.question3 = ''
        this.$refs.registerQuestion.question2 = '-1'
        this.$refs.registerQuestion.question3 = '-1'
        return
      }
      if (this.step >= 5) return
      this.step++
    },
    systemAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.areaCodeList = res.data
      })
    },
    jump(path) {
      location.href = path
    }
  }
}
</script>
<style lang="scss" scoped>

#register {
  background: #fff !important;
  font-family: Arial;
}

.register {
  min-height: 100vh;

  .register-left {
    width: 50%;
    box-sizing: border-box;
    padding: 20px 40px;

    .head {
      height: 40px;
      .logo {
        width: 150px;
        img {
          width: 100%;
        }
      }
    }

    .content {
      width: 100%;
      height: calc(100vh - 80px);
      overflow: auto;

      .register-box {
        width: 420px;
        font-size: 14px;
        color: #606266;
        margin-top: 12vh;
        position: relative;

        .back {
          position: absolute;
          top: -50px;
          left: 0;
        }

        h4 {
          color: #303133;
          font-size: 32px;
          margin-bottom: 16px;
        }

        .step-tab {
          width: 100%;
          margin-top: 40px;
          .item {
            width: 206px;
            height: 34px;
            box-sizing: border-box;
            padding: 4px 0;
            border-bottom: 4px solid #F5F9EA;
            color: #909399;
            font-size: 12px;
          }
          .sel {
            border-bottom: 4px solid #9AC331;
          }
        }

        .register-question {
          width: 100%;
          margin-top: 24px;
        }

        .register-btn {
          width: 100%;
          height: 40px;
          border-radius: 2px;
          margin-top: 20px;
        }

        .terms {
          text-align: center;
          font-size: 12px;
          line-height: 18px;
          margin-top: 20px;

          .showError {
            /deep/ .el-checkbox__inner {
              border: 1px solid #F56C6C;
            }
          }

          /deep/ .el-checkbox {
            margin: 0;
            margin-right: 2px;
          }
        }

        .register-info {
          width: 100%;
          margin-top: 24px;

          .send-button {
            width: 92px;
            height: 40px;
            border-radius: 2px;
          }

          .verification {
            /deep/ .el-form-item__content{
              display: flex;
            }
          }

          /deep/ .el-form-item {
            margin-bottom: 20px;
          }
          /deep/ .el-form-item--medium .el-form-item__label {
            width: 100%;
            display: flex;
            line-height: 22px;
            padding-bottom: 4px !important;
          }
          /deep/ .el-form-item__content .el-input__inner {
            border-radius: 2px;
            height: 40px;
          }

          /deep/ .el-input-group__prepend{
            background-color: unset;
          }
        }
      }
    }
  }
  .right-banner {
    width: 50%;
    box-sizing: border-box;
  }
}

/* 移动端样式 */
.code-tip {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  padding: 10px 0;
}
.userinfoTitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #000000;
  display: inline-block;
  margin-bottom: 24px;
}
/deep/.el-checkbox {
  margin-bottom: 15px;
}
/deep/.el-checkbox__label {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #000000;
}
/deep/.el-dialog--center {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
}
.code-button {
  width: 30% !important;
  color: #99c41c;
  display: inline-block;
  height: 46px;
  border: 1px solid #99c41c;
}

.or-box {
  padding: 15px 0 10px 0;
  color: rgb(190, 190, 190);
  div {
    width: 38%;
    height: 1.5px;
    background: rgb(190, 190, 190);
  }
  span {
    padding: 0 15px;
  }
}

.mobile-login-btton {
  width: 2.32rem;
  height: 44px;
  color: #99c41c;
  border-radius: 4px;
  border: 1px solid #99c41c;
}
.mobile-code-button {
  height: 44px;
  border-radius: 4px;
}
.mobile-register /deep/.el-form-item__content {
  line-height: 44px;
}
// .mobile-register /deep/ .is-error {
//   height: 1rem !important;
// }
.mobile-register-btn {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  margin-top: 0.2rem;
  color: #fff;
}
.mobile-help {
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #7b7b7b;
  padding-top: 0.2rem;
  text-align: center;
}
/deep/.el-form-item {
  margin-bottom: 12px;
}
</style>
<style>
.abcRioButton.abcRioButtonLightBlue {
  width: 36px !important;
}
</style>
